import React from "react";

const PreBox = ({ children, style }) => (
	<div
		style={{
			display: "block",
			padding: "9.5px",
			margin: "0 0 10px",
			fontSize: "13px",
			lineHeight: "1.42857143",
			color: "#333",
			wordBreak: "break-all",
			wordWrap: "break-word",
			backgroundColor: "#f5f5f5",
			border: "1px solid #ccc",
			borderRadius: "4px",
			...style,
		}}
	>
		{children}
	</div>
);

export default PreBox;
